// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvUtcTimeZone } from '../TradingViewPrimitives/TvConstants';
export class TvTimeZoneHelper {
    static getTimeZoneForTV(timeZoneID) {
        const UTC = TvUtcTimeZone;
        let result = timeZoneID !== null && timeZoneID !== void 0 ? timeZoneID : UTC;
        if (result === 'GMT') {
            result = UTC;
        }
        if (result === 'Europe/Kiev') {
            return 'Europe/Kyiv';
        }
        return result;
    }
}
